<template>
  <div class="ds-control mobile dsf_teas_student_course">
    <div class="search">
      <van-search
        v-model="keywords"
        shape="round"
        @input="search"
        placeholder="搜索"
      />
    </div>
    <div class="content">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        v-if="list.length > 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          finished-text="没有更多了"
          @load="getList"
        >
          <div class="list">
            <!-- <div
              class="list-item"
              :class="{ out_time: item.state === 3 }"
              v-for="(item, index) in list"
              :key="index"
              @click="clickItem(item)"
            >
              <div
                class="course-name"
                :class="{
                  'text-green': item.state === 1,
                }"
              >
                {{ item.courseName }}
              </div>
              <div class="row">
                <div class="flex-sub time">{{ item.courseTimeSdate }}</div>
                <div class="flex-sub name">{{ item.teacher }}</div>
              </div>
              <div class="row">
                <div class="flex-sub moshi">{{ item.teachFrom }}</div>
                <div class="flex-sub addr">
                  {{ item.place ? item.place : "暂无" }}
                </div>
              </div>
              <div class="row">
                <div class="flex-sub ewm" v-if="attendTypeValue == '3'">
                  {{ item.attendTypeText }}
                </div>
                
                <div class="flex-sub position" v-if="attendTypeValue == '1'">
                  {{ item.attendTypeText }}
                </div>
                
                <div class="flex-sub qdm" v-if="attendTypeValue == '2'">
                  {{ item.attendTypeText }}
                </div>
              </div>
              <div class="detail">
                <div class="row" v-if="item.signInTime">
                  <div class="label">签到时间：</div>
                  <div class="value flex-sub">{{ item.signInTime }}</div>
                </div>
                <div class="row" v-if="item.signInPlace">
                  <div class="label">签到地点：</div>
                  <div class="value flex-sub">
                    {{ item.signInPlace }}
                  </div>
                </div>
                <div class="row" v-if="item.signOutTime">
                  <div class="label">签退时间：</div>
                  <div class="value flex-sub">{{ item.signOutTime }}</div>
                </div>
                <div class="row" v-if="item.signOutPlace">
                  <div class="label">签退地点：</div>
                  <div class="value flex-sub">
                    {{ item.signOutPlace }}
                  </div>
                </div>
              </div>
              <div class="status" v-if="item.state != 1 && item.state != 2">
                
                <img
                  v-if="item.resultValue === '1'"
                  class="status-img"
                  src="../../assets/styles/themes/img/chuqin.png"
                  alt=""
                  srcset=""
                />
                <img
                  v-else-if="'678'.indexOf(item.resultValue) !== -1"
                  class="status-img"
                  src="../../assets/styles/themes/img/gongjia.png"
                  alt=""
                  srcset=""
                />
                <img
                  v-else
                  class="status-img"
                  src="../../assets/styles/themes/img/yichang.png"
                  alt=""
                  srcset=""
                />
                <p
                  class="statusText"
                  :class="{
                    'text-green': item.resultValue === '1',
                    'text-blue': '678'.indexOf(item.resultValue) !== -1,
                    'text-red': '1678'.indexOf(item.resultValue) === -1,
                  }"
                >
                  {{ item.resultText }}
                </p>
              </div>
            </div> -->

            <DsfMobileTeasCell
              class="attance_cell"
              :style="{'margin-top': (index == 0 ? '0' : '10') + 'px'}"
              :class="item.state | attancingStatus"
              v-for="(item, index) in list"
              :key="index"
              @click.native="clickItem(item)"
              :title="item.courseName"
              :titleEllipsis="2"
            >
              <template #titleLeft>
                <div class="xuanxiu" v-if="item.electiveValue == 1">选修</div>
              </template>
              <template #titleRight>
                <div v-if="item.state != 1 && item.state != 2">
                  <div v-if="item.resultValue == '1' || item.resultValue == '5'" class="chuqin"> {{item.resultText}} </div>
                  <div v-else-if="'678'.indexOf(item.resultValue) !== -1" class="qingjia"> {{item.resultText}} </div>
                  <div v-else-if="item.resultValue == 9" class="weiqian"> {{item.resultText}} </div>
                  <div v-else class="yichang"> {{item.resultText}} </div>
                </div>
              </template>
              <DsfMobileTeasCellItem icon="icon-shijian" :value="item.courseTimeSdate"></DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem icon="icon-icon-teacher" :value="item.teacher ? item.teacher : '暂无'"></DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem icon="icon-location-hollow" :value="item.place ? item.place : '暂无'"></DsfMobileTeasCellItem>
            </DsfMobileTeasCell>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>
  </div>
</template>

<script>
const testData = [
  {
    id: "522ce46b3eb84051b5b05b8172ef75ee",
    courseName: "江苏省开发区放管服改革经验介绍",
    scheduleNoonId: "0ef3f30873234c1dbbae178837ab9b61",
    courseTimeSdate: "2021-03-17 08:40",
    teacher: null,
    place: null,
    teachFrom: null,
    attendTypeText: null,
    attendTypeValue: null,
    resultValue: "9",
    resultText: "未签",
    signInTime: null,
    signInPlace: null,
    signOutTime: null,
    signOutPlace: "",
  },
  {
    id: "9e6d44d18bc747688c2ae7f2d928e6d0",
    courseName: "英语课",
    scheduleNoonId: "ee97829c920443faa048f14c79f21dd4",
    courseTimeSdate: "2021-03-17 14:30",
    teacher: null,
    place: null,
    teachFrom: null,
    attendTypeText: null,
    attendTypeValue: null,
    resultValue: "9",
    resultText: "未签",
    signInTime: null,
    signInPlace: null,
    signOutTime: null,
    signOutPlace: "",
  },
];
export default dsf.component({
  name: "DsfMobileTeasStudentCourse",
  mixins: [$mixins.control],
  ctrlCaption: "学员考勤",
  design: {
    isMask: false,
  },
  // status: 1考勤中  2未开始  3已结束
  // resultValue: 1出勤 2迟到 3晚到 4早退 5签退 6病假 7事假 8公假 9未签
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/mobile/attendance/queryStuCourseAttend",
    },
    scanCodeUrl: {
      type: String,
      default: "/teas/mobile/attendance/scanCodeAttend",
    },
    locationUrl: {
      type: String,
      default: "/teas/mobile/attendance/positioningAttendance",
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      classId: "",
      keywords: "",
      list: [],
      attendInfor: {}, // 扫码考勤
    };
  },
  filters: {
    attancingStatus: function(status) {
      if (status == 1) {
        return 'attancing'
      } else if (status == 3) {
        return 'ending'
      }

    }
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.classId = this.$route.query.classId;
      this.getList();
    }
    if (dsf.client.weixin() && window.$wx) {
      window.$wx.init();
    }
    // 获取考勤信息
    this.getAddanceInfor();
  },
  activated: function() {
    this.onRefresh();
  },
  methods: {
    // 点击方法
    clickItem(item) {
       console.log(1111)
      if (this.isDesign) { 
        return;
      }
     
      if (this.$listeners["rowClick"]) {
        this.$dispatch("rowClick", item);
      } else {
        var url = '/mobile/teas/attendance/mobile/mobile-stuClassWubieAddanceDetail?relId=' + item['id'] + '&type=1';
        this.$router.push({
          path: url
        })
      }
    },
    search: _.debounce(function () {
      this.onRefresh();
    }, 300),
    // 获取考勤类型及信息
    getAddanceInfor() {
      this.$http
        .get("teas/mobile/attendance/findAttendTypeInfo")
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.attendInfor = res.data;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    // 获取列表数据
    getList(isRefresh = false) {
      // const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .get(this.sourcesUrl, {
          pageNum: this.pageNum,
          classId: this.classId,
          search: this.keywords,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list;
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true;
        })
        .always(() => {
          this.loading = false;
          this.refreshing = false;
          // dsf.layer.closeLoading(loading);
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
    },
  },
});
</script>
